import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_organic-purity/artifacts/r6j3sknm_GAB%20Organics%20Logo%20without%20BG.png" 
              alt="GAB Organics" 
              className="footer-logo"
            />
            <p className="footer-tagline">Organic You Can Trust.<br />Purity You Can Feel.</p>
            <p className="footer-desc">
              Thoughtfully sourced organic essentials for conscious living.
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Our Products</h4>
            <ul className="footer-links">
              <li>Organic Spices</li>
              <li>Millets</li>
              <li>Fresh Dairy</li>
              <li>Raw Honey</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Us</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={18} />
                <a href="mailto:support@gaborganics.com">support@gaborganics.com</a>
              </li>
              <li>
                <Phone size={18} />
                <a href="tel:+917736959355">+91 7736959355</a>
              </li>
              <li>
                <MapPin size={18} />
                <span>Trivandrum, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2022 GAB Organics. All rights reserved.</p>
          <p className="footer-credit">Crafted with care for conscious living</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
